<template>
  <div class="container">
    <img src="@/assets/img/esun_logo.png" />
    <img src="@/assets/img/chouti.png" @click="isShowMenu = !isShowMenu" />
    <div class="menu_help" v-if="isShowMenu">
      <div class="nav">
        <img src="@/assets/img/logo.png" />
        <i class="el-icon-close" @click="isShowMenu = !isShowMenu"></i>
      </div>
      <div class="list">
        <div
          class="item"
          v-for="(item, index) in routes"
          :key="index"
          :class="item.path === $router.history.current.path ? 'active' : ''"
          @click="JumpTo(item.path)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="lang"><span @click="change">中/EN</span></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowMenu: false,
      routes: [
        { label: this.$t("message.Home"), path: "/" },
        { label: this.$t("message.OverallPlan"), path: "/OverallPlan_phone" },
        {
          label: this.$t("message.IndustrySolutions"),
          path: "/IndustrySolutions_phone",
        },
        {
          label: this.$t("message.CustomerStories"),
          path: "/CustomerStories_phone",
        },
        {
          label: this.$t("message.TrainingServe"),
          path: "/TrainingServe_phone",
        },
        { label: this.$t("message.AboutUs"), path: "/AboutUs_phone" },
      ],
    };
  },
  // computed:{
  //     routes(){
  //         return this.$router.options.routes
  //     }
  // },
  mounted() {
    console.log(this.$router);
  },
  methods: {
    JumpTo(path) {
      this.isShowMenu = false;
      this.$router.push(path);
    },
    change() {
      this.isShowMenu = false;
      if (this.$i18n.locale == "en") {
        this.$i18n.locale = "zh";
        localStorage.setItem("lang", this.$i18n.locale);
      } else {
        this.$i18n.locale = "en";
        localStorage.setItem("lang", this.$i18n.locale);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  align-items: center;
  .menu_help {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 99;
    .nav {
      width: 80%;
      height: 3rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 2rem;
    }
    .list {
      width: 70%;
      margin-top: 4rem;
      .item {
        margin: 1rem 0;
        font-family: 思源黑体;
        font-weight: 550;
        color: #252c33;
        &.active {
          color: #2f54eb;
        }
      }
    }
    .lang {
      width: 70%;
      margin-top: 5rem;
      font-family: 思源黑体;
      font-weight: 600;
    }
  }
}
</style>